angular.module('billing').controller('PaymentSummaryCtrl',
    ['$scope','$state','$window', '$stateParams', '$sce', 'TransitionManager', 'PatientPortalStorageRepository', 'BillingService',
        function ($scope,$state, $window, $stateParams, $sce, TransitionManager, PatientPortalStorageRepository, BillingService) {
            'use strict';

            var txId = $stateParams.txId;
            var loginUserId = PatientPortalStorageRepository.getLoginUser().id;
            $scope.loading = true;
            $scope.model = {
                ReceiptHtml: ''
            };

            $scope.statementsOnly = getState();

            function getState()
            {
                return $state.current.alternativeLoginRoute;
            }

            function loadPaymentResult() {
                $scope.loading = true;
                $scope.removeHttpError();

                loginUserId = PatientPortalStorageRepository.getLoginUser().id;
                var receiptRequestDto = {
                    TxId: txId,
                    RecipientEnumText: 'CUST',
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString()
                };

                BillingService.getReceiptHtml(receiptRequestDto)
                    .then(function (data) {
                        if (data.ReceiptHtml) {
                            $scope.model.ReceiptHtml = $sce.trustAsHtml(data.ReceiptHtml);
                        } else {
                            $scope.addHttpError('Receipt is null.');
                        }
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function done() {
                if($scope.statementsOnly)
                {
                    TransitionManager.transition({appRoute: 'paymentStatementsOnly'});
                }
                else{
                    TransitionManager.transition({appRoute: 'billing'});
                }
            }

            function print() {
                $window.print();
            }

            $scope.done = done;
            $scope.print = print;
            loadPaymentResult();
        }]);